// queries/useAdminDeleteRemixGalleryImage.ts
"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetch } from "libs";
import { DELETE_REMIX_GALLERY_IMAGE } from "api";

export const useAdminDeleteRemixGalleryImage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      const response = await fetch(DELETE_REMIX_GALLERY_IMAGE(id), {
        method: "DELETE",
      });

      return await response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["remixGallery"] });
      console.log("Remix gallery image deletion successful");
    },
    onError: (error) => {
      console.error("Error in useAdminDeleteRemixGalleryImage:", error.message);
    },
  });
};

export default useAdminDeleteRemixGalleryImage;
